<template>
  <AdminMachineList :pk="'CML-'" :lockedFilters="{ UnitIdList: [$route.params.unitId], CustomerId: customerId }"
    allowSelectAll :openPreview="!previewItem && showPicker" :itemDeleteFunc="itemDeleteFunc" :groupByUnit="false">
    <template v-slot:preview>
      <MachinePickerPane v-if="showPicker" :key="customerId"
        :lockedFilters="{ CustomerId: customerId, ExcludedUnitIdList: [$route.params.unitId] }" :customerId="customerId"
        multiple allowSelectAll :selectText="$t('servicesystem.common_objects.commonterms.add')"
        :onSelectMethod="sf => handleSelect(sf)" ref="picker">
      </MachinePickerPane>
    </template>
  </AdminMachineList>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import AdminMachineList from "@/views/admin/machines/AdminMachineList.vue";
import MachinePickerPane from "@/views/job/newjob/cards/machines/MachinePickerPane2.vue";

export default {
  name: "ViewUnitMachines",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    AdminMachineList,
    MachinePickerPane,
  },
  mixins: [clientAPI],

  data() {
    return {};
  },

  methods: {
    async handleSelect(selectionFilter) {
      await this.addMachinesToUnit(this.$route.params.unitId, selectionFilter);
      if (this.$refs.picker) {
        this.$refs.picker.close();
      }
      this.$router.replace({ query: { ...this.$route.query, timestamp: this.getNowTime(this.oldTimeFormat) } });
    },

    async itemDeleteFunc(item) {
      await this.removeMachinesFromUnit(this.$route.params.unitId, [item.Id]);
    },
  },

  computed: {
    showPicker() {
      return this.$route.query.picker == 'machine';
    },
    previewItem() {
      return this.$route.query.machineId;
    },

    unit() {
      return this.containerItem;
    },
    customerId() {
      return this.unit?.CustomerId;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>